import { useMemo } from 'react'
import PredictionSummary from './PredictionSummary'
import { normalizePredictionData } from './predictionView.util';
import { Box } from '@mui/material';
import PredictionCard from './PredictionCard';
import { NormalizedPredictionKind } from './enums';
import PredictionHeading from './PredictionHeading';
import { PadithiEnum } from '../../../utils/enums';

const PredictionView = ({ predictionData, user, filter }) => {

  const { conditionType, predictionType } = filter;

  const { userCurrentTimezone } = user;

  const summary = useMemo(() => {
    return predictionData?.summary
  }, [predictionData])

  const beforeMoonChangeSummary = useMemo(() => {
    return predictionData?.moonChangeSummaries?.beforeMoonChange
  }, [predictionData])

  const afterMoonChangeSummary = useMemo(() => {
    return predictionData?.moonChangeSummaries?.afterMoonChange
  }, [predictionData])


  const normalized = useMemo(
    () => normalizePredictionData(predictionData),
    [predictionData]
  );

  const predictions = useMemo(() => {
    if (normalized.type === NormalizedPredictionKind.NORMAL) {
      return normalized?.predictions
    }
  }, [normalized]);

  const beforeMoonChangePredictions = useMemo(() => {
    if (normalized.type === NormalizedPredictionKind.MOON_CHANGE) {
      return normalized?.before?.predictions
    }
  }, [normalized]);

  const afterMoonChangePredictions = useMemo(() => {
    if (normalized.type === NormalizedPredictionKind.MOON_CHANGE) {
      return normalized?.after?.predictions
    }
  }, [normalized]);


  const beforeMoonChangePredictionsTitle = useMemo(() => {
    return beforeMoonChangePredictions?.length && afterMoonChangePredictions?.length ? 'Before Moon Change Predictions' : 'Predictions'
  }, [beforeMoonChangePredictions, afterMoonChangePredictions])

  const afterMoonChangePredictionsTitle = useMemo(() => {
    return beforeMoonChangePredictions?.length && afterMoonChangePredictions?.length ? 'After Moon Change Predictions' : 'Predictions'
  }, [beforeMoonChangePredictions, afterMoonChangePredictions])

  return (
    <Box sx={{ py: 1 }}>
      {/* Normal predictuon */}
      {summary && (
        <PredictionSummary
          title='Summary'
          summary={summary}
        />
      )}

      {predictions && predictions.length > 0 && predictions.map(prediction => (
        <PredictionCard
          key={prediction._id}
          prediction={prediction}
          user={user}
          filter={filter}
        />
      ))}

      {/* Before moon change predictuon */}
      {beforeMoonChangeSummary && (
        <PredictionSummary
          title={beforeMoonChangeSummary && afterMoonChangeSummary ? 'Before Moon Change Summary' : 'Summary'}
          summary={beforeMoonChangeSummary}
        />
      )}


      {conditionType !== PadithiEnum.MASTER && beforeMoonChangePredictions && beforeMoonChangePredictions.length > 0 &&
        <PredictionHeading title={beforeMoonChangePredictionsTitle} />
      }

      {beforeMoonChangePredictions && beforeMoonChangePredictions.length > 0 && beforeMoonChangePredictions.map(prediction => (
        <PredictionCard
          key={prediction._id}
          prediction={prediction}
          user={user}
          filter={filter}
        />
      ))}


      {/* Normal predictuon */}
      {afterMoonChangeSummary && (
        <PredictionSummary
          title={beforeMoonChangeSummary && afterMoonChangeSummary ? 'After Moon Change Summary' : 'Summary'}
          summary={afterMoonChangeSummary}
        />
      )}

      {conditionType !== PadithiEnum.MASTER && afterMoonChangePredictions && afterMoonChangePredictions.length > 0 &&
        <PredictionHeading title={afterMoonChangePredictionsTitle} />
      }
      {afterMoonChangePredictions && afterMoonChangePredictions.length > 0 && afterMoonChangePredictions.map(prediction => (
        <PredictionCard
          key={prediction._id}
          prediction={prediction}
          user={user}
          filter={filter}
        />
      ))}
    </Box>
  )
}

export default PredictionView


